/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownRightIcon24Solid = forwardRef('ArrowDCornerDownRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.5 16A4.5 4.5 0 0 1 3 11.5v-9a1.5 1.5 0 1 1 3 0v9A1.5 1.5 0 0 0 7.5 13h10.129l-4.19-4.19a1.5 1.5 0 0 1 2.122-2.12l5.503 5.503a3.263 3.263 0 0 1 0 4.614l-5.503 5.504a1.5 1.5 0 0 1-2.122-2.122L17.63 16H7.5Z" })));
});
